import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@services';

@Component({
  selector: 'app-event-modal',
  templateUrl: './event-modal.component.html',
  styleUrls: ['./event-modal.component.scss'] 
})
export class EventModalComponent implements OnInit {
  @Input() eventData: any = null;
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  eventForm!: FormGroup;
  recurrence = 1;
  weekdays = [
  { label: $localize`:@@monday:Lunes`, value: 1 },
  { label: $localize`:@@tuesday:Martes`, value: 2 },
  { label: $localize`:@@wednesday:Miércoles`, value: 3 },
  { label: $localize`:@@thursday:Jueves`, value: 4 },
  { label: $localize`:@@friday:Viernes`, value: 5 },
  { label: $localize`:@@saturday:Sábado`, value: 6 },
  { label: $localize`:@@sunday:Domingo`, value: 0 }
];
  constructor(private fb: FormBuilder,private translate: TranslateService) {}

  ngOnInit(): void {
    console.log('🟢 EventModalComponent cargado');
    this.eventForm = this.fb.group({
      title: ['', [Validators.required]],
      description: [''],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      startHour: ['', Validators.required],
      endHour: ['', Validators.required],
      notification: [false],
      reminderMinutes: [5],
      isRecurring: [false],
      recurrence: [0],
      interval: [1],
      byweekday: [[]],
      contentId: [''],
      contentType: ['']
    });

    if (this.eventData) {
    // ⚠️ Evita que byweekday sea null
    this.eventData.byweekday = this.eventData.byweekday || [];
    this.eventForm.patchValue(this.eventData);
  }
  }

  submit(): void {
    if (this.eventForm.invalid) return;
    const data = this.eventForm.value;

    data.startDate = new Date(data.startDate).toISOString().split('T')[0];
    data.endDate = new Date(data.endDate).toISOString().split('T')[0];
    console.log(data);
    //this.save.emit(data);
  }
  toggleWeekday(dayValue: number, event: any): void {
    const control = this.eventForm.get('byweekday');
    if (!control) return;

    const selectedDays = control.value || [];

    if (event.target.checked) {
      if (!selectedDays.includes(dayValue)) {
        control.setValue([...selectedDays, dayValue]);
      }
    } else {
      control.setValue(selectedDays.filter((d: number) => d !== dayValue));
    }
  }
}
